@if(isMobileWidgetExpanded()) {
  <div class="search-widget-v4-mobile-expanded">
    <div class="search-widget-v4-mobile-expanded__heading">
      <button
        (click)="onClosePanelClick()"
        aria-label="Stäng"
        class="icon-button"
        type="button"
      >
        <app-ui-icon color="var(--grey-1)" name="close" size="md"></app-ui-icon>
      </button>
      <div>Vad letar du efter?</div>
    </div>
    <div class="search-widget-v4-mobile-expanded__form-line">
      <div class="input-wrap grow">
        <app-search-widget-v4-mobile-free-search-form
          (fieldFocused)="onFreeSearchFieldFocused($event)"
          (updateSuggestions)="onUpdateFreeSearchSuggestions($event)"
          [inferredCareProviderTypeAreaId]="inferredCareProviderTypeAreaId()"
          [inferredCategoryTypeId]="inferredCategoryTypeId()"
          [mainCareProviderTypeId]="mainCareProviderTypeId()"
        ></app-search-widget-v4-mobile-free-search-form>
      </div>
    </div>
    <div class="search-widget-v4-mobile-expanded__form-line">
      <div class="input-wrap grow">
        <app-search-widget-v4-mobile-places-form
          (fieldFocused)="onPlacesFieldFocused($event)"
          (searchByLocationTrigger)="searchByLocationClick()"
          (updateSuggestions)="onUpdatePlacesSuggestions($event)"
          [inferredCareProviderTypeAreaId]="inferredCareProviderTypeAreaId()"
          [inferredCategoryTypeId]="inferredCategoryTypeId()"
          [mainCareProviderTypeId]="mainCareProviderTypeId()"
          [pageType]="pageType()"
        ></app-search-widget-v4-mobile-places-form>
      </div>
      <div class="input-wrap">
        <app-ui-button
          (onClick)="onSubmitClick($event)"
          [color]="'green'"
          [disabled]="!isSubmitButtonActive()"
          [expanded]="'block'"
          [size]="'lg'"
          class="test-search-btn"
        >
          Sök
        </app-ui-button>
      </div>
    </div>

    <div class="search-widget-v4-mobile-expanded__mega-menu-button">
      @if(whichIsFocused() === SearchWidgetFreeSearchFieldsEnum.FREESEARCH) {
        <app-ui-button
          (onClick)="onCategoriesClick()"
          [color]="'tertiary'"
          [disabled]="false"
          [expanded]="'block'"
          [size]="'md'"
          class="test-mega-menu-button"
        >
          <app-ui-icon name="list"></app-ui-icon>
          Alla kategorier
        </app-ui-button>
      }
      @if(whichIsFocused() === SearchWidgetFreeSearchFieldsEnum.PLACE) {
        <app-ui-button
          (onClick)="onPlacesClick()"
          [color]="'tertiary'"
          [disabled]="false"
          [expanded]="'block'"
          class="test-mega-menu-button"
        >
          <app-ui-icon name="place_marker"></app-ui-icon>
          Se alla platser
        </app-ui-button>
      }

    </div>

    <div class="search-widget-v4-mobile-expanded__suggestions">
      <app-search-widget-v4-mobile-suggestions
        [inferredCareProviderTypeAreaId]="inferredCareProviderTypeAreaId()"
        [inferredCategoryTypeId]="inferredCategoryTypeId()"
        [mainCareProviderTypeId]="mainCareProviderTypeId()"
        [pageType]="pageType()"
        [suggestTypes]="suggestTypes()"
        [whichIsFocused]="whichIsFocused()"
      ></app-search-widget-v4-mobile-suggestions>
    </div>
  </div>
}

